import { Component, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { LaasOption } from 'src/app/core/models/laas-option';
import { PageInfo } from 'src/app/core/models/page-info';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { AddressMaintainanceService } from 'src/app/features/setting/service/address-maintainance.service';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { InputValidators } from 'src/app/shared/validators/input-validators';
import { DeliveryOrderService } from '../../services/delivery-order.service';
import { ForwarderService } from '../../services/forwarder.service';
import { PlantService } from '../../services/plant-service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
@Component({
  selector: 'laas-vmi-do-create',
  templateUrl: './vmi-do-create.component.html',
  styleUrls: ['./vmi-do-create.component.scss']
})
export class VmiDOCreateComponent extends SessionBaseComponent {

  readonly viewPermissionCode = PermissionConstants.VmiDOCreate;
  @ViewChild('searchTable') searchTable!: DataTableComponent;
  currentLang: string = this.laasSetting.language;
  // loading
  pageLoading: boolean = false;
  tableLoading: boolean = false;
  uploadLoading: boolean = false;

  // dropdown options
  facilityOptions: LaasOption[] = [];
  plantOptions: LaasOption[] = [];
  storerOptions: LaasOption[] = [];
  vendorOptions: LaasOption[] = [];
  brandOptions: LaasOption[] = [];
  forwarderOptions: LaasOption[] = [];

  // search condition Accordion
  showConditionAccordion: boolean = true;


  // preference def
  preferenceKey: string = UserPreferenceConstants.VMIDOCreateSearchTable;
  detailPreferenceKey: string = UserPreferenceConstants.VMIDOCreateSearchTableDetail;

  // searchForm
  searchForm: FormGroup;

  // default pageable, 僅用到 pageSize, pageIndex
  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  // default sort by SeqNo desc
  sortOrder: SortOrder = {
    property: 'SeqNo',
    direction: -1
  };

  tableColumn = [
    { field: 'doNo', header: 'VMIDOCreate.Table.Column.DoNo', sort: true },
    { field: 'facility', header: 'VMIDOCreate.Table.Column.Facility', sort: true },
    { field: 'vendorPlant', header: 'VMIDOCreate.Table.Column.VendorPlant', sort: true },
    { field: 'vendorNo', header: 'VMIDOCreate.Table.Column.Vendor', sort: true },
    { field: 'storer', header: 'VMIDOCreate.Table.Column.Storer', sort: true },
    { field: 'isBonded', header: 'VMIDOCreate.Table.Column.IsBonded', sort: true },
    { field: 'etd', header: 'VMIDOCreate.Table.Column.ETD', sort: true },
    { field: 'deliveryType', header: 'VMIDOCreate.Table.Column.DeliveryType', sort: true },
    { field: 'incoTerm', header: 'VMIDOCreate.Table.Column.IncoTerm', sort: true },
    { field: 'assignForwarder', header: 'VMIDOCreate.Table.Column.AssignForwarder', sort: true },
    { field: 'address', header: 'VMIDOCreate.Table.Column.Address', sort: true },
    { field: 'createUser', header: 'VMIDOCreate.Table.Column.CreateUser', sort: true },
    { field: 'createDt', header: 'VMIDOCreate.Table.Column.CreateDt', dataType: 'date', sort: true },
    { field: 'updateUser', header: 'VMIDOCreate.Table.Column.UpdateUser', sort: true },
    { field: 'updateDt', header: 'VMIDOCreate.Table.Column.UpdateDt', dataType: 'date', sort: true },
  ];

  detailColumns = [
    { field: 'externLineNo', header: 'VMIDOCreate.Table.Column.ExternLineNo' },
    { field: 'sku', header: 'VMIDOCreate.Table.Column.Sku' },
    { field: 'manufacturerPartNumber', header: 'VMIDOCreate.Table.Column.ManufacturerPartNumber' },
    { field: 'brand', header: 'VMIDOCreate.Table.Column.Brand' },
    { field: 'vendorLot', header: 'VMIDOCreate.Table.Column.VendorLot' },
    { field: 'vendorDc', header: 'VMIDOCreate.Table.Column.vendorDc' },
    { field: 'coo', header: 'VMIDOCreate.Table.Column.coo' },
    { field: 'originalQty', header: 'VMIDOCreate.Table.Column.OriginalQty' },
  ];

  searchResults: any[] = [];

  constructor(injector: Injector,
    private formBuilder: FormBuilder,
    private commonDataService: CommonDataService,
    private dropdownOptionsService: DropdownOptionsService,
    private addressMaintainanceService: AddressMaintainanceService,
    private plantService: PlantService,
    private facilityService: FacilityService,
    private doService: DeliveryOrderService,
    private forwarderService: ForwarderService,
  ) {
      super(injector);

      // 搜尋條件初始化 & 驗證
      this.searchForm = this.formBuilder.group({
        facilityList: [[this.laasSetting.facility]],
        plantList: [[]],
        storerList: [[]],
        vendorList: [[], Validators.required],
        brandList: [[]],
        manufacturerPartNumber: [],
        sku: [],
      });

  }

  // 上傳、下載
  showUploadDOModal: boolean = false;
  selectedFile: File | null = null;

  async ngOnInit(): Promise<void> {

    // 取所有下拉單
    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (result: { optionDesc: string; optionCode: string }[]) => {
        this.facilityOptions = result.map(
          (x) => ({
            label: x.optionDesc,
            value: x.optionCode,
          })
        );
      },
    });

    this.plantService.getVendorPlantOptions().subscribe({
      next: (plantList: { plantId: string }[])=> {
        const uniquePlantIds: string[] = Array.from(new Set(plantList.map((x) => x.plantId)));
        this.plantOptions = uniquePlantIds.map(plantId => ({
          label: plantId,
          value: plantId
        }));
      }
    });

    this.addressMaintainanceService.getStorerOptions().subscribe({
      next: (result: { optionCode: string }[]) => {
        this.storerOptions = result.map(
          (x) => ({
            label: x.optionCode,
            value: x.optionCode,
          })
        )
        this.storerOptions.sort((a, b) => a.label.localeCompare(b.label));
      },
    });

    this.facilityService.getAllVendorOptions().subscribe({
      next: (result: {optionCode: string, optionDesc: string, }[]) => {
        this.vendorOptions = result.map((x) => ({
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          })
        );

        // 設定預設值為第一個選項
        if (this.vendorOptions.length > 0) {
          this.searchForm.patchValue({
            vendorList: [this.vendorOptions[0].value]
          });
        }
      }
    });

    this.dropdownOptionsService.getBrandOptions(1)
      .subscribe({
        next: (options: { brandName: string }[]) => {
          this.brandOptions = options.map(x => ({ label: x.brandName, value: x.brandName }));
        }
    });

    this.forwarderService.getForwarderOptionsAll().subscribe({
        next: (options: { label: string, value: string }[]) => {
          this.forwarderOptions = options.map(x => ({ label: x.label, value: x.value }));
        }
    })

  }

  // click sort emit
  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.searchTable.setCurrentPage(0);
    this.searchVMIForm();
  }

  // change page emit
  tablePageChange(event: any) {
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.pageInfo.pageSize = event.rows;
    this.searchVMIForm();
  }

  resetClickBtn(): void {
    this.searchForm.reset({
        facilityList: [this.laasSetting.facility],
        vendorList: this.vendorOptions.length > 0 ? [this.vendorOptions[0].value] : []
      }
    );
  }

  searchVMIForm() {
    // 驗證必填欄位
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFields'));
      return;
    }

    const req = Object.assign({... this.searchForm.value}, {
      pageIndex: this.pageInfo.pageIndex,
      pageSize: this.pageInfo.pageSize,
      sortOrder: this.sortOrder
    });
    this.searchVMI(req);
  }
  searchVMI(req: any = {}): void {

    // call search
    this.tableLoading = true;
    this.doService.searchVMIDeliveryOrder(req).subscribe({
      next: resp => {
        this.searchResults = resp.content;
        this.searchTable.setPageInfo(resp.totalElements);
        this.tableLoading = false;
      },
      error: resp => {
        this.tableLoading = false;
        if (resp.error) {
          this.toastErrorMessage(resp.error);
        }
      },
      complete: () => {
      },
    });
  }

  searchDetailClick(event: any): void {
    const isClosed = event.expanded;
    if (isClosed) {
      return;
    }

    // call api
    const seqNo = event.rowData.seqNo;
    const rowData = event.rowData;
    this.tableLoading = true;
    this.doService.searchVMIDeliveryOrderDetail({mainSeqNo: seqNo}).subscribe({
      next: resp => {
        rowData.details = resp;
        this.tableLoading = false;
      },
      error: resp => {
        this.tableLoading = false;
        if (resp.error) {
          this.toastErrorMessage(resp.error);
        }
      },
      complete: () => {

      },
    });
  }

  // 上傳、下載
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      input.value = '';
    }
  }

  uploadFile() {
    this.uploadLoading = true;
    this.doService.uploadVMIDOFile(this.selectedFile).subscribe({
      next: resp => {
        this.toastService.success(this.translateService.instant('VMIDOCreate.Message.UploadSuccess'));
        // upload 成功後, 反查資料 by SeqNos
        this.pageInfo.pageIndex = 0;
        this.searchTable.setCurrentPage(0);
        const req = {
          seqNos: resp.seqNos,
          pageIndex: this.pageInfo.pageIndex,
          pageSize: this.pageInfo.pageSize,
          sortOrder: this.sortOrder
        }
        this.searchVMI(req);
      },
      error: resp => {
        if (resp.error) {
          this.toastErrorMessage(resp.error);
        }
        this.showUploadDOModal = false;
        this.selectedFile = null;
        this.uploadLoading = false;
      },
      complete: () => {
        this.showUploadDOModal = false;
        this.selectedFile = null;
        this.uploadLoading = false;
      },
    })
  }

  downloadTemplate() {
    const fileType = 'VMIDOCreateTemplate';
    this.commonDataService.getSystemParam(fileType).subscribe({
      next: result => {
        const searchObj = {
          sn: result[0].sn,
          version: result[0].version
        };

        this.doService.downloadFile(searchObj).subscribe(x => {
          const blob = new Blob([x], { type: 'application/octet-stream' });
          const downloadURL = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = 'VMIDOCreateTemplate.xlsx';
          link.click();
        });
      }
    });
  }

  closedUpploadModal() {
    this.selectedFile = null;
  }

}
